<template>
  <tooltip v-if="hasPermission(permission)" label="Pause" type="small" placement="top">
    <button type="button" @click="onClick" class="button">
      <span class="icon">
        <i class="fa fa-pause"></i>
      </span>
    </button>
  </tooltip>
</template>

<script>
    import mixin from 'components/mixin';

    export default {
        mixins: [mixin],
        name: "pause-button",
        props: {
            permission: Array
        },
        methods: {
            onClick() {
                this.$emit('click');
            }
        }
    }
</script>

<style scoped>

</style>